import React, { useContext, useEffect, useState } from "react";
import { useNotification } from "../../NotificationContext";
import {
  getShiftDefinition,
  saveShiftDefinition,
  updateShiftDefinition,
} from "../../apis/shiftDefinition";
import { LanguageContext } from "../../providers/LanguageProvider";

const AddShiftDefinition: React.FC<{ closeModal: () => void; editableId: number | null }> = ({
  closeModal,
  editableId,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    startTime: "09:00",
    endTime: "17:00",
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const { showNotification } = useNotification();
  const { translate: t } = useContext(LanguageContext);

  useEffect(() => {
    if (editableId) {
      getShiftDefinition(editableId).then((res: any) => {
        const data = res.data?.data || res.data;
        setFormData({
          name: data?.name || "",
          startTime: data?.startTime || data?.start_time || "09:00",
          endTime: data?.endTime || data?.end_time || "17:00",
        });
      });
    }
  }, [editableId]);

  const validate = () => {
    const errs: Record<string, string> = {};
    if (!formData.name.trim()) errs.name = "* Name is required";
    if (!formData.startTime) errs.startTime = "* Start time is required";
    if (!formData.endTime) errs.endTime = "* End time is required";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    if (editableId) {
      updateShiftDefinition({ id: editableId, ...formData }).then(() => {
        showNotification("success", "Shift updated successfully", "", "topRight");
        closeModal();
      }).catch((err: any) => {
        showNotification("error", "Failed to update shift", err?.response?.data?.message || "", "topRight");
      });
    } else {
      saveShiftDefinition(formData).then(() => {
        showNotification("success", "Shift created successfully", "", "topRight");
        closeModal();
      }).catch((err: any) => {
        showNotification("error", "Failed to create shift", err?.response?.data?.message || "", "topRight");
      });
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">{t("name")}</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="mt-1 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm"
          placeholder="e.g. Morning Shift"
        />
        {errors.name && <span className="text-sm text-red-500">{errors.name}</span>}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">Start Time</label>
          <input
            type="time"
            value={formData.startTime}
            onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
            className="mt-1 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm"
          />
          {errors.startTime && <span className="text-sm text-red-500">{errors.startTime}</span>}
        </div>
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">End Time</label>
          <input
            type="time"
            value={formData.endTime}
            onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
            className="mt-1 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm"
          />
          {errors.endTime && <span className="text-sm text-red-500">{errors.endTime}</span>}
        </div>
      </div>
      <div className="flex justify-start gap-4 pt-4">
        <button
          onClick={handleSave}
          type="button"
          className="px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary hover:bg-hover"
        >
          {editableId ? t("update") : t("save")}
        </button>
        <button onClick={closeModal} type="button" className="text-sm font-semibold leading-6 text-gray-900">
          {t("cancel")}
        </button>
      </div>
    </div>
  );
};

export default AddShiftDefinition;
